import { render, staticRenderFns } from "./CustomersAccountsReceivable.vue?vue&type=template&id=7bfb3009&scoped=true"
import script from "./CustomersAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./CustomersAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./CustomersAccountsReceivable.vue?vue&type=style&index=0&id=7bfb3009&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb3009",
  null
  
)

export default component.exports